import { Content as ContentNoLazyLoadable } from './Content';

export const Content = ContentNoLazyLoadable;
